import root from "./_root.js";
var Symbol$1 = root.Symbol;
export {
  Symbol$1 as default
};
